interface PilotIconProps {
  className?: string;
  color?: string;
}

export const PilotIcon = ({ className = 'w-6 h-6', color = 'var(--ods-system-greys-white)' }: PilotIconProps) => (
  <svg viewBox="0 0 156.8 83" fill={color} xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M55.7,0C54.3,0,53,0.6,52,1.5c-1,1-1.6,2.3-1.6,3.7c0,0.7,0.1,1.4,0.4,2S51.5,8.5,52,9
      c0.5,0.5,1.1,0.9,1.7,1.1c0.6,0.3,1.3,0.4,2,0.4c1.4,0,2.7-0.6,3.6-1.6c1-1,1.5-2.3,1.5-3.7c0-1.4-0.5-2.7-1.5-3.7
      C58.4,0.6,57.1,0,55.7,0L55.7,0z"
    />
    <path d="M75.7,0.4h-7.4v64.7h7.4V0.4z" />
    <path
      d="M104.2,21.2c-13,0-22.6,10-22.6,22.4s9.6,22.4,22.6,22.4c12.9,0,22.5-10,22.5-22.4S117.1,21.2,104.2,21.2z
       M104.2,59.2c-9,0-15-6.9-15-15.5s6-15.5,15-15.5c9,0,14.9,6.9,14.9,15.5S113.2,59.2,104.2,59.2L104.2,59.2z"
    />
    <path
      d="M156.8,29v-6.8h-12.4V10.8l-7.4,3.7v7.6h-9.2V29h9.2v23.6c0,9,5.7,13.2,13.2,13.2c2.3,0,4.5-0.3,6.7-1v-6.6
      c-1.7,0.6-3.5,0.9-5.3,0.9c-4.7,0-7.2-1.8-7.2-7.3V29H156.8z"
    />
    <path
      d="M22.6,20.8c-5.6,0-11,2.1-15.1,5.8v-4.8H0V83h7.4V60.1c2.7,2.5,6,4.2,9.5,5.1c3.5,0.9,7.3,0.9,10.8,0.1
      c3.6-0.8,6.9-2.6,9.6-5c2.8-2.4,4.9-5.5,6.2-8.9c1.3-3.4,1.8-7.1,1.4-10.7c-0.4-3.6-1.7-7.1-3.8-10.1c-2.1-3-4.8-5.5-8.1-7.2
      C29.8,21.7,26.2,20.8,22.6,20.8L22.6,20.8z M22.6,58.5c-3,0-5.9-0.9-8.4-2.6c-2.5-1.7-4.4-4-5.6-6.8c-1.1-2.8-1.4-5.8-0.9-8.7
      c0.6-2.9,2-5.6,4.1-7.7c2.1-2.1,4.8-3.6,7.8-4.1c2.9-0.6,6-0.3,8.7,0.9c2.8,1.1,5.1,3.1,6.8,5.6c1.7,2.5,2.5,5.4,2.5,8.4
      c0,2-0.4,4-1.1,5.8c-0.8,1.8-1.9,3.5-3.3,4.9c-1.4,1.4-3.1,2.5-4.9,3.3C26.5,58.2,24.6,58.6,22.6,58.5L22.6,58.5z"
    />
    <path d="M22.8,49c3.2,0,5.8-2.6,5.8-5.8s-2.6-5.8-5.8-5.8s-5.8,2.6-5.8,5.8S19.7,49,22.8,49z" />
    <path d="M45.8,22.1l1.7,6.8H52v36.3h7.4V22.1H45.8z" />
  </svg>
);
